import React, { useEffect, useLayoutEffect, useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './QuizModal.scss';
import { BREAKPOINT_MD } from "../stores/constants";
import OptionModel from "../models/OptionModel";
import Tooltip from "../components/Tooltip";
import { Info2Icon } from "../icons/Info2Icon";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import ConfigurableCard from "../components/ConfigurableCard";
import { ResultCard } from "../components/ResultCard";
import { _t } from '../utils/Lang';


function SingleButton({ text, onClick, checked = false, tooltip, className }) {

    const classes = ['QuizModal__button'];
    if (checked) {
        classes.push('checked');
    }
    if (className) {
        classes.push(className);
    }
    return (
        <div
            className={classes.join(' ')}
            onClick={onClick}>
            {text}
        </div>
    )
}

function CheckboxOption({ text, checked = false, onClick, tooltip }) {

    const classes = ['QuizModal__option'];
    if (checked) {
        classes.push('checked');
    }
    return (
        <div
            onClick={onClick}
            className={classes.join(' ')}
        >
            <Checkbox
                value={text}
                checked={checked}
                onChange={() => { }}
                style={{ pointerEvents: 'none' }}
            >
                {text}

            </Checkbox>
            {tooltip ? (

                <Tooltip
                    title={tooltip}
                >
                    <button type="button" className="p-0 ms-1 mb-1" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Info2Icon />
                    </button>
                </Tooltip>
            ) : null}
        </div>
    )
}


const QuizModal = observer(() => {
    const ref = React.createRef();
    const next = React.createRef();


    const quiz = store.quiz;

    return (
        <Modal
            className="modal-md"
            onClose={e => {
                quiz.close();
            }}
            isOpen={quiz.isOpen}

        >
            <div className="QuizModal">
                <div className="QuizModal__title">
                    {quiz.currentStep.title}
                    <div className="QuizModal__subtitle">
                        {quiz.currentStep.subtitle}
                    </div>
                </div>
                <div className="QuizModal__progress">
                    {quiz.visibleSteps.filter(f => !f.result).map((step, idx) => (
                        <div className={`QuizModal__progress-item ${idx < quiz.stepIndex ? 'active' : ''} ${idx === quiz.stepIndex ? 'current' : ''}`} key={step.index}>

                        </div>
                    ))}

                </div>
                {!quiz.currentStep.result ? (
                    <>
                        <div className="QuizModal__options">
                            {
                                quiz.currentStep.options.map(option => {

                                    if (quiz.currentStep.multiple) {
                                        return <CheckboxOption
                                            key={option.value}
                                            text={option.text}
                                            value={option.value}
                                            tooltip={option.tooltip}
                                            checked={quiz.getStepValue(quiz.currentStepIndex, []).includes(option.value)}
                                            onClick={() => {
                                                let values = quiz.getStepValue(quiz.currentStepIndex, []);
                                                const prevValues = [...values];
                                                if (values.includes(option.value)) {
                                                    values = values.filter(v => v !== option.value);
                                                } else {
                                                    values.push(option.value);
                                                }
                                                console.log({ prevValues, values });
                                                quiz.setStepValue(quiz.currentStepIndex, values);
                                            }} />
                                    }
                                    return <SingleButton
                                        key={option.value}
                                        className={option.className}
                                        text={option.text}
                                        tooltip={option.tooltip}
                                        checked={quiz.getStepValue(quiz.currentStepIndex) === option.value}
                                        onClick={() => {
                                            quiz.setStepValue(quiz.currentStepIndex, option.value);
                                        }} />
                                })
                            }
                        </div>
                        <div className="QuizModal__navigtion">
                            <Button
                                className="primary hollow"
                                disabled={quiz.prevDisabled}
                                onClick={e => {
                                    quiz.prevStep();
                                }}>
                                {_t('quiz_back')}
                            </Button>
                            <Button
                                className="primary"
                                disabled={quiz.nextDisabled}
                                onClick={e => {
                                    quiz.nextStep();
                                }}>
                                {_t('quiz_next')}
                            </Button>
                        </div>

                    </>
                ) : (
                    <>
                        <div className="QuizModal__result mb-1">
                            <Swiper
                                modules={[Navigation, Pagination]}
                                slidesPerView={1.1}
                                spaceBetween={20}
                                navigation={{
                                    enabled: true,
                                    nextEl: '.QuizModal__swiper-button-next',
                                    prevEl: '.QuizModal__swiper-button-prev',
                                }}
                                pagination={{
                                    enabled: true,
                                    clickable: true,
                                    dynamicBullets: true
                                }}
                            >
                                <SwiperSlide>
                                    <ResultCard></ResultCard>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <ResultCard></ResultCard>
                                </SwiperSlide>
                                <button className="QuizModal__swiper-button-prev"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="39.5" y="39.5" width="39" height="39" rx="19.5" transform="rotate(-180 39.5 39.5)" stroke="#212121" />
                                    <path d="M28 20L12 20M12 20L18 26M12 20L18 14" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </button>
                                <button className="QuizModal__swiper-button-next"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#212121" />
                                    <path d="M12 20H28M28 20L22 14M28 20L22 26" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </button>
                                <div className="QuizModal__overlay" style={{ pointerEvents: 'none' }}></div>
                            </Swiper>
                        </div>
                        <div className="QuizModal__navigtion">

                            <Button
                                className="primary hollow"
                                disabled={quiz.prevDisabled}
                                onClick={e => {
                                    quiz.reset();
                                }}>
                                {_t('quiz_retake')} <svg width="14" height="16" className="ms-2" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.66667 15.3206C5.7425 15.3206 4.87632 15.1467 4.06812 14.799C3.25993 14.4512 2.55375 13.9752 1.94958 13.371C1.34542 12.7669 0.869444 12.0607 0.521666 11.2525C0.173889 10.4443 0 9.57813 0 8.65396H0.833333C0.833333 10.279 1.39931 11.6574 2.53125 12.7894C3.66319 13.9213 5.04167 14.4873 6.66667 14.4873C8.29167 14.4873 9.67014 13.9213 10.8021 12.7894C11.934 11.6574 12.5 10.279 12.5 8.65396C12.5 7.02896 11.934 5.65049 10.8021 4.51854C9.67014 3.3866 8.29167 2.82063 6.66667 2.82063H6.34937L7.70521 4.17646L7.11542 4.77583L4.74354 2.38792L7.1475 0L7.73708 0.599375L6.34937 1.98729H6.66667C7.59083 1.98729 8.45701 2.16118 9.26521 2.50896C10.0734 2.85674 10.7796 3.33271 11.3837 3.93688C11.9879 4.54104 12.4639 5.24722 12.8117 6.05542C13.1594 6.86361 13.3333 7.72979 13.3333 8.65396C13.3333 9.57813 13.1594 10.4443 12.8117 11.2525C12.4639 12.0607 11.9879 12.7669 11.3837 13.371C10.7796 13.9752 10.0734 14.4512 9.26521 14.799C8.45701 15.1467 7.59083 15.3206 6.66667 15.3206Z" fill="#1F1F1F" />
                                </svg>

                            </Button>
                            <Button
                                className="primary"

                                onClick={e => {
                                    quiz.close();
                                    quiz.reset();
                                    store.openComparision();
                                }}>
                                {_t('quiz_compare')}
                            </Button>
                        </div>

                    </>
                )}


            </div>


        </Modal>
    )
});
QuizModal.displayName = 'QuizModal';

export default QuizModal